import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const addAssessmentToReturn = {
  name: "addAssessmentToReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    productId: z.string(),
    assessmentId: zExt.objectId(),
    assigneeId: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), productAssessmentId: z.string() }),
};
